export default class Socialfollow {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		if(!this.isset('paddingBottom')) {
			this.item.paddingBottom = '10px';
		}

		if(!this.isset('paddingTop')) {
			this.item.paddingTop = '10px';
		}

		if(!this.isset('align')) {
			this.item.align = 'center';
		}

		if(!this.isset('type')) {
			this.item.type = '2';
		}

		if(!this.isset('facebook')) {
			this.item.facebook = '';
		}

		if(!this.isset('facebook_active')) {
			this.item.facebook_active = true;
		}

		if(!this.isset('googleplus')) {
			this.item.googleplus = '';
		}

		if(!this.isset('googleplus_active')) {
			this.item.googleplus_active = false;
		}

		if(!this.isset('tumblr')) {
			this.item.tumblr = '';
		}

		if(!this.isset('tumblr_active')) {
			this.item.tumblr_active = false;
		}

		if(!this.isset('linkedin')) {
			this.item.linkedin = '';
		}

		if(!this.isset('linkedin_active')) {
			this.item.linkedin_active = false;
		}

		if(!this.isset('twitter')) {
			this.item.twitter = '';
		}

		if(!this.isset('twitter_active')) {
			this.item.twitter_active = true;
		}

		if(!this.isset('instagram')) {
			this.item.instagram = '';
		}

		if(!this.isset('instagram_active')) {
			this.item.instagram_active = true;
		}

		if(!this.isset('web')) {
			this.item.web = '';
		}

		if(!this.isset('web_active')) {
			this.item.web_active = false;
		}




		


		if(!this.isset('id')) {
			this.item.id = false;
		}

	}
}


// WEBPACK FOOTER //
// ./helpers/socialfollow.js